import { render, staticRenderFns } from "./EditingScoringMethod_v2.vue?vue&type=template&id=5a45382a&"
import script from "./EditingScoringMethod_v2.vue?vue&type=script&lang=js&"
export * from "./EditingScoringMethod_v2.vue?vue&type=script&lang=js&"
import style0 from "./EditingScoringMethod_v2.vue?vue&type=style&index=0&id=5a45382a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports